<template>
  <Default class="view-contacts">
    <div class="container">
      <FormPasswordResetEmail
        v-if="!isPasswordFormShown"
          :token="token"
          @redirect="redirectToForgotPassword"
          @success="showPasswordForm"
      />
     <FormPasswordResetPassword v-else :token="token" :email="email" @success="redirectToLogin" />
    </div>
  </Default>
</template>
<script setup>
import Default from "@/layouts/Default.vue";
import FormPasswordResetEmail from "@/components/form/FormPasswordResetEmail.vue";
import FormPasswordResetPassword from "@/components/form/FormPasswordResetPassword.vue";
import { computed, onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
import { setLanguageParameter } from "@/composables/language.js";


const email = ref('');
const isPasswordFormShown = ref(false);
const router = useRouter();

const token = computed(() => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('token');
});

onMounted(async () => {
  if (!token.value) {
    redirectToForgotPassword();
  }
  setLanguageParameter();
});

const showPasswordForm = (userEmail) => {
  email.value = userEmail;
  isPasswordFormShown.value = true;
};

const redirectToForgotPassword = () => {
  router.push({ name: 'forgot-password' });
};

const redirectToLogin = () => {
  router.push({ name: 'login' });
};
</script>

<style lang="postcss" scoped>
.reset-container {
  @apply w-full;
}

@screen md {
  .reset-container {
    @apply w-1/2 mx-auto;
  }
}

.reset-form {
  @apply w-full;
}

@screen md {
  .reset-form {
    @apply w-full;
  }
}
</style>